import { render, staticRenderFns } from "./OperationManual.vue?vue&type=template&id=4f8dde7c"
var script = {}
import style0 from "./OperationManual.vue?vue&type=style&index=0&id=4f8dde7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports